import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader, Button} from 'semantic-ui-react';
import {Actions} from '../../../../../../common/actions';
import {downloadFile} from '../../../../../../common/util/file';
import BulletinRecordTable from './bulletinRecordTable';

class BulletinDownloadRecord extends Component {
  componentDidUpdate() {
    const {fileURL} = this.props;
    if (fileURL) {
      downloadFile(fileURL);
      this.props.clearBulletinURLFile();
    }
  }

  onDownload = () => {
    const {bulletinId} = this.props;
    this.props.downloadExcelRecord(bulletinId);
  }

  renderLoader() {
    return (
      <Table striped className="toyota-grid">
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan="100%">
              <Loader active inline="centered" content="Ejecutando" />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  render() {
    const {records, loading} = this.props;

    return (
      <>
        <div className="buttons-actions">
          <Button primary disabled={loading} onClick={this.onDownload}>
            Descarga Historial
          </Button>
        </div>
        <Card raised fluid className="bulletin-table">
          {loading ? (
            this.renderLoader()
          ) : (
            <BulletinRecordTable list={records} loading={loading} />
          )}
        </Card>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'records': state.bulletin.downloadRecord,
    'loading': state.bulletin.loadingRecord,
    'loadingFile': state.bulletin.loadingFile,
    'fileURL': state.bulletin.fileURL,
  };
};

const {downloadExcelRecord, clearBulletinURLFile, withRouter, navigateTo} =
  Actions;

const mapDispatchToProps = {
  downloadExcelRecord,
  clearBulletinURLFile,
  navigateTo,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BulletinDownloadRecord)
);
